// src/pages/DanhBa.js
import React, { useState, useEffect, useCallback } from "react";
import { fetchData, addData, updateData, deleteData } from "../services/api";
import { useThongBao, ThongBao, DangTai, docQuyen, hoiXoa } from "../vo";

// ============================================================
// 📞 DANH BẠ NHÀ MÌNH (Đợt 5B)
// ------------------------------------------------------------
// Chân dung mục 4.6: số thợ điện, thợ nước, bác sĩ quen, nhà xe — những số
// **chỉ cần khi gấp**, và **luôn không tìm thấy lúc gấp**, vì nằm rải rác
// trong máy từng người.
//
// Cả tháng mới mở một lần. Nhưng lúc mở là lúc đang cần gấp — nước đang
// tràn, người đang sốt. Nên trang này không đo bằng "đẹp", nó đo bằng
// HAI THỨ:
//
//   1. TÌM RA NHANH  → ô tìm nằm sẵn trên đầu, gõ vài chữ là lọc ngay.
//      Lọc theo cả tên, vai trò LẪN ghi chú — lúc gấp người ta hay nhớ
//      "cái ông sửa ống nước ở đầu hẻm" chứ không nhớ tên ông ấy.
//
//   2. BẤM MỘT CÁI LÀ GỌI ĐƯỢC → số điện thoại là một liên kết `tel:`.
//      Trên điện thoại, chạm vào là máy mở sẵn màn hình gọi. Đây là lý do
//      tồn tại của cả trang này. ⚠️ ĐỪNG đổi nó thành chữ thường.
//
// Số điện thoại là BẮT BUỘC (một dòng danh bạ không có số thì trang này mất
// luôn lý do tồn tại), nhưng chỉ kiểm CẤU TRÚC chứ không ép khuôn: nhà xe có
// số kiểu "1900 6067 (bấm phím 2)", bệnh viện có số nhánh. Xem hàm kiemSo.
//
// ⚠️ Component DongDanhBa nằm NGOÀI hàm DanhBa — xem bài học
// docs/bai-hoc/2026-09-07-06_ham-trong-ham-lam-mat-con-tro.md
// ============================================================

// Lọc lấy phần máy có thể quay số. Giữ dấu + cho số quốc tế.
//
// ⚠️ ĐỪNG rút gọn thành `s.replace(/[^0-9+]/g, "")`. Viết vậy thì
// "1900 6067 (bấm phím 2)" ra thành "190060672" — con số 2 trong lời ghi
// chú dính luôn vào số điện thoại, và bấm là GỌI NHẦM SỐ. Lỗi kiểu đó
// chỉ lộ ra đúng lúc đang gấp, là lúc tệ nhất để nó lộ.
//
// Quy tắc: phần ghi chú luôn bắt đầu bằng CHỮ ("bấm phím 2", "gặp anh
// Tư", "giờ hành chính"). Nên cắt từ chữ cái đầu tiên trở đi; phần trước
// đó mới là số. Nhờ vậy "(028) 3822 1234" vẫn quay được đủ, vì trong đó
// không có chữ cái nào.
const soQuayDuoc = (s) => {
  if (!s) return "";
  const viTriChu = s.search(/\p{L}/u);
  const phanSo = viTriChu === -1 ? s : s.slice(0, viTriChu);
  return phanSo.replace(/[^0-9+]/g, "");
};

// ============================================================
// ☎️ KIỂM SỐ ĐIỆN THOẠI — KIỂM CẤU TRÚC, KHÔNG KIỂM NHÀ MẠNG
// ------------------------------------------------------------
// Số điện thoại là BẮT BUỘC. Một dòng danh bạ không có số thì trang này
// mất luôn lý do tồn tại — nó sinh ra để "bấm một cái là gọi được".
//
// ⚠️ CỐ Ý KHÔNG kiểm đầu số nhà mạng (076, 090, 032…). Bảng đầu số ở
// Việt Nam thay đổi theo thời gian; nhà mạng được cấp đầu số mới là app
// từ chối một số CÓ THẬT mà người ta đang cầm trong tay — đúng lúc đang
// gấp. Kiểu hỏng đó tệ hơn kiểu hỏng nó chữa. Đừng thêm bảng đầu số.
//
// Máy chủ kiểm y hệt. Kiểm ở đây chỉ để báo NGAY, khỏi phải chờ mạng.
// ============================================================
const kiemSo = (raw) => {
  const chuoi = (raw || "").trim();
  if (chuoi === "") return "Chưa nhập số điện thoại";
  const chiSo = soQuayDuoc(chuoi).replace(/[^0-9]/g, "");
  if (chiSo === "") return "Chưa nhập số điện thoại";
  if (chiSo.length < 8) return "Số điện thoại ngắn quá — cần ít nhất 8 chữ số";
  if (chiSo.length > 15) return "Số điện thoại dài quá — nhiều nhất 15 chữ số";
  if (chiSo.startsWith("0") && chiSo.length !== 10 && chiSo.length !== 11)
    return "Số bắt đầu bằng 0 phải có đúng 10 hoặc 11 chữ số";
  return null;
};

const khongDau = (s) =>
  (s || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .toLowerCase();

function DongDanhBa({
  d,
  dangSua,
  form,
  onDoiForm,
  onMoSua,
  onLuuSua,
  onHuySua,
  onXoa,
  suaDuoc,
}) {
  if (dangSua) {
    return (
      <li className="db-dong db-dong-sua">
        <input
          type="text"
          value={form.ten}
          onChange={(e) => onDoiForm("ten", e.target.value)}
          placeholder="Tên (bắt buộc)"
          maxLength={100}
          className="db-o"
          autoFocus
        />
        <input
          type="text"
          value={form.vai_tro}
          onChange={(e) => onDoiForm("vai_tro", e.target.value)}
          placeholder="Thợ điện, Bác sĩ, Nhà xe…"
          maxLength={60}
          className="db-o"
        />
        <input
          type="tel"
          value={form.dien_thoai}
          onChange={(e) => onDoiForm("dien_thoai", e.target.value)}
          placeholder="Số điện thoại (bắt buộc)"
          maxLength={60}
          className="db-o"
        />
        <input
          type="text"
          value={form.ghi_chu}
          onChange={(e) => onDoiForm("ghi_chu", e.target.value)}
          placeholder="Ghi chú: ở đâu, giờ nào gọi được…"
          maxLength={300}
          className="db-o db-o-rong"
        />
        <div className="db-hang-nut">
          <button onClick={onLuuSua} className="nut nut-xanh">Lưu</button>
          <button onClick={onHuySua} className="nut nut-xam">Thôi</button>
        </div>
      </li>
    );
  }

  const so = soQuayDuoc(d.dien_thoai);

  return (
    <li className="db-dong">
      <div className="db-chu">
        <div className="db-ten">
          {d.ten}
          {d.vai_tro && <span className="db-vai-tro"> · {d.vai_tro}</span>}
        </div>
        {d.ghi_chu && <div className="db-ghi-chu">{d.ghi_chu}</div>}
      </div>

      {/* Chạm vào là máy mở màn hình gọi. Đây là lý do trang này tồn tại. */}
      {d.dien_thoai ? (
        so ? (
          <a href={`tel:${so}`} className="db-goi" title="Bấm để gọi">
            📞 {d.dien_thoai}
          </a>
        ) : (
          <span className="db-goi db-goi-tat">{d.dien_thoai}</span>
        )
      ) : (
        /* Chỉ còn gặp ở những dòng lưu TRƯỚC khi số điện thoại thành bắt
           buộc. Bấm ✏️ và điền số vào là hết. */
        <span className="db-goi db-goi-tat" title="Dòng cũ chưa có số — bấm ✏️ để điền">
          thiếu số — bấm ✏️
        </span>
      )}

      {suaDuoc && (
        <span className="db-nut">
          <button onClick={onMoSua} className="btn-edit" title="Sửa">✏️</button>
          <button onClick={onXoa} className="btn-delete" title="Xóa">🗑️</button>
        </span>
      )}
    </li>
  );
}

const FORM_TRONG = { ten: "", vai_tro: "", dien_thoai: "", ghi_chu: "" };

function DanhBa({ user }) {
  const [ds, setDs] = useState([]);
  const [dangTai, setDangTai] = useState(true);
  const [tim, setTim] = useState("");

  const [moThem, setMoThem] = useState(false);
  const [formThem, setFormThem] = useState(FORM_TRONG);
  const [dangGui, setDangGui] = useState(false);

  const [suaId, setSuaId] = useState(null);
  const [formSua, setFormSua] = useState(FORM_TRONG);

  const { laAdmin, them: coTheThem } = docQuyen(user);

  const { bao, noiBao } = useThongBao();

  const taiLai = useCallback(async () => {
    try {
      const d = await fetchData("danh-ba");
      setDs(Array.isArray(d) ? d : []);
    } catch (err) {
      noiBao("⚠️ Không tải được danh bạ");
    } finally {
      setDangTai(false);
    }
  // `noiBao` khai được vào đây vì nó được ghi nhớ trong useThongBao
  // (useCallback). Thời bản cũ nó là hàm mới mỗi lần vẽ, khai vào đây là
  // tải lại danh sách vô tận.
  }, [noiBao]);

  useEffect(() => {
    taiLai();
  }, [taiLai]);

  const themSo = async (e) => {
    if (e) e.preventDefault();
    if (formThem.ten.trim() === "") {
      noiBao("⚠️ Chưa nhập tên");
      return;
    }
    const loiSo = kiemSo(formThem.dien_thoai);
    if (loiSo) {
      noiBao("⚠️ " + loiSo);
      return;
    }
    setDangGui(true);
    try {
      await addData("danh-ba", formThem);
      setFormThem(FORM_TRONG);
      setMoThem(false);
      await taiLai();
    } catch (err) {
      noiBao("⚠️ Không thêm được");
    } finally {
      setDangGui(false);
    }
  };

  const luuSua = async (d) => {
    if (formSua.ten.trim() === "") {
      noiBao("⚠️ Tên không được để trống");
      return;
    }
    const loiSo = kiemSo(formSua.dien_thoai);
    if (loiSo) {
      noiBao("⚠️ " + loiSo);
      return;
    }
    try {
      await updateData("danh-ba", d.id, formSua);
      setSuaId(null);
      await taiLai();
    } catch (err) {
      noiBao("⚠️ Không sửa được — chỉ người đã thêm mới sửa được");
    }
  };

  const xoaSo = async (d) => {
    if (!hoiXoa("số điện thoại", d.ten)) return;
    try {
      await deleteData("danh-ba", d.id);
      await taiLai();
    } catch (err) {
      noiBao("⚠️ Không xóa được — chỉ người đã thêm mới xóa được");
    }
  };

  if (dangTai) return <DangTai gi="danh bạ" />;

  // Lọc theo cả tên, vai trò lẫn ghi chú, và bỏ dấu trước khi so —
  // lúc gấp không ai gõ dấu cẩn thận, gõ "tho dien" phải ra "Thợ điện".
  const tuTim = khongDau(tim.trim());
  const hienThi = tuTim
    ? ds.filter((d) =>
        khongDau(`${d.ten} ${d.vai_tro || ""} ${d.ghi_chu || ""} ${d.dien_thoai || ""}`).includes(tuTim),
      )
    : ds;

  return (
    <div className="card">
      <h3>📞 Danh bạ nhà mình</h3>
      <ThongBao bao={bao} />

      <p className="db-mo-dau">
        Số thợ điện, thợ nước, bác sĩ quen, nhà xe — những số chỉ cần khi gấp.
        Bấm vào số là gọi được ngay.
      </p>

      {ds.length > 0 && (
        <input
          type="search"
          value={tim}
          onChange={(e) => setTim(e.target.value)}
          placeholder="Tìm: tên, nghề, hoặc ghi chú…"
          className="db-o-tim"
        />
      )}

      {coTheThem && (
        <button
          onClick={() => {
            setMoThem(!moThem);
            setFormThem(FORM_TRONG);
          }}
          className="btn-add"
        >
          {moThem ? "❌ Hủy" : "➕ Thêm một số"}
        </button>
      )}

      {moThem && (
        <form onSubmit={themSo} className="db-form">
          <input
            type="text"
            value={formThem.ten}
            onChange={(e) => setFormThem({ ...formThem, ten: e.target.value })}
            placeholder="Tên (bắt buộc) — ví dụ: Anh Tư"
            maxLength={100}
            className="db-o"
            autoFocus
          />
          <input
            type="text"
            value={formThem.vai_tro}
            onChange={(e) => setFormThem({ ...formThem, vai_tro: e.target.value })}
            placeholder="Nghề — Thợ điện, Bác sĩ, Nhà xe…"
            maxLength={60}
            className="db-o"
          />
          <input
            type="tel"
            value={formThem.dien_thoai}
            onChange={(e) => setFormThem({ ...formThem, dien_thoai: e.target.value })}
            placeholder="Số điện thoại (bắt buộc) — 0912 345 678"
            maxLength={60}
            className="db-o"
          />
          <input
            type="text"
            value={formThem.ghi_chu}
            onChange={(e) => setFormThem({ ...formThem, ghi_chu: e.target.value })}
            placeholder="Ghi chú: ở đâu, giờ nào gọi được… (không bắt buộc)"
            maxLength={300}
            className="db-o db-o-rong"
          />
          <button type="submit" className="nut nut-xanh" disabled={dangGui}>
            {dangGui ? "Đang lưu…" : "Lưu vào danh bạ"}
          </button>
        </form>
      )}

      {ds.length === 0 && (
        <p className="db-trong">
          Danh bạ còn trống. Thêm dần những số cả nhà hay phải đi hỏi nhau —
          thợ điện, thợ nước, bác sĩ quen, nhà xe.
        </p>
      )}

      {ds.length > 0 && hienThi.length === 0 && (
        <p className="db-trong">Không tìm thấy số nào khớp “{tim}”.</p>
      )}

      {hienThi.length > 0 && (
        <ul className="db-danh-sach">
          {hienThi.map((d) => (
            <DongDanhBa
              key={d.id}
              d={d}
              dangSua={suaId === d.id}
              form={formSua}
              onDoiForm={(cot, v) => setFormSua((f) => ({ ...f, [cot]: v }))}
              onMoSua={() => {
                setSuaId(d.id);
                setFormSua({
                  ten: d.ten || "",
                  vai_tro: d.vai_tro || "",
                  dien_thoai: d.dien_thoai || "",
                  ghi_chu: d.ghi_chu || "",
                });
              }}
              onLuuSua={() => luuSua(d)}
              onHuySua={() => setSuaId(null)}
              onXoa={() => xoaSo(d)}
              suaDuoc={laAdmin || d.nguoi_them === user.id}
            />
          ))}
        </ul>
      )}
    </div>
  );
}

export default DanhBa;
